import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FleetWebApi from "../Api/FleetWebApi";
import ResultsDetails from "./ResultDetails";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

const LocationResult = (props) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [searchResultDetails, setSearchResultDetails] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    getLocationSearch(props.location);
  }, [props.location]); // Add props.location to dependency array to ensure it re-runs when props.location changes

  const getLocationSearch = async (location) => {
    try {
      const result = await FleetWebApi.getLocationSearch(location);
      setSearchResultDetails(result);
      setIsLoaded(true);
    } catch (error) {
      setError(error);
      setIsLoaded(true);
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <CircularProgress color="secondary" />;
  } else {
    if (
      searchResultDetails.response[0].length === 0 &&
      searchResultDetails.response[1].length === 0 &&
      searchResultDetails.response[2].length === 0
    ) {
      return <h3> No results</h3>;
    } else if (
      searchResultDetails.response[0].length === 1 &&
      searchResultDetails.response[1].length === 0 &&
      searchResultDetails.response[2].length === 0
    ) {
      navigate("/location/dashboard/" + searchResultDetails.response[0][0].id);
      return null;
    } else {
      return (
        <>
          <h1>Search Results for: {props.location}</h1>
          <AppBar position="static" style={{ background: "#2E3B55" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="secondary"
            >
              <Tab label="Search Results" />
            </Tabs>
          </AppBar>
          <TabPanel value={tabValue} index={0}>
            <Grid>
              <ResultsDetails
                searchResultDetails={searchResultDetails.response}
              />
            </Grid>
          </TabPanel>
        </>
      );
    }
  }
};

export default LocationResult;
